import React from 'react'
import styles from './styles.css'

interface NavbarState {
  responsiveMenuOpened: boolean
  stickyOn: boolean
}

interface ChildrenProps extends NavbarState {
  onClickMenuButton: () => void
  toggleMenu: (value: boolean) => void
}

interface Props {
  children: (value: ChildrenProps) => React.ReactNode
  onMobileMenuChange: (value: boolean) => void
  stickyOffset?: number
  mobileBreakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xlg' | 'xxlg'
}

class Navbar extends React.Component<Props, NavbarState> {
  constructor(props: Props) {
    super(props)
    this.state = { responsiveMenuOpened: false, stickyOn: false }
  }

  private mobileNav = React.createRef<HTMLDivElement>()

  componentDidMount() {
    // Add event listener to window resize
    this.onScroll()
    window.addEventListener('scroll', this.onScroll, false)
    window.addEventListener('resize', this.onResize, false)
    window.addEventListener('mousedown', this.onGenericClick, false)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('mousedown', this.onGenericClick)
    this.toggleBodyOverflow(false)
  }

  onScroll = () => {
    const { stickyOffset } = this.props
    if (stickyOffset) {
      if (window.pageYOffset > stickyOffset) {
        this.setState({ stickyOn: true })
      } else {
        const { stickyOn } = this.state
        if (stickyOn) {
          this.setState({ stickyOn: false })
        }
      }
    }
  }

  onResize = () => {
    const { mobileBreakpoint = 'md' } = this.props
    const breakpoint = parseInt(styles[`breakpoint-${mobileBreakpoint}`].replace('px', ''), 10)
    if (window.outerWidth > breakpoint) {
      this.toggleMenu(false)
    }
  }

  onGenericClick = (event: MouseEvent) => {
    const { responsiveMenuOpened } = this.state
    if (
      responsiveMenuOpened &&
      this.mobileNav.current &&
      !this.mobileNav.current.contains(event.target as Node)
    ) {
      this.toggleMenu(false)
    }
  }

  onClickMenuButton = () => {
    const { responsiveMenuOpened } = this.state
    this.toggleMenu(!responsiveMenuOpened)
  }

  toggleMenu = (value: boolean) => {
    this.toggleBodyOverflow(value)
    this.setState({ responsiveMenuOpened: value })
  }

  toggleBodyOverflow = (on: boolean) => {
    const { onMobileMenuChange } = this.props
    const body = document.querySelector('body')
    if (body) {
      if (on) {
        body.style.overflow = 'hidden'
      } else {
        body.style.overflow = 'visible'
      }
    }
    onMobileMenuChange(on)
  }

  render() {
    const { stickyOn, responsiveMenuOpened } = this.state
    return (
      <nav ref={this.mobileNav}>
        {this.props.children({
          responsiveMenuOpened,
          stickyOn,
          onClickMenuButton: this.onClickMenuButton,
          toggleMenu: this.toggleMenu
        })}
      </nav>
    )
  }
}

export default Navbar
